var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-exception"},[_c('div',{staticClass:"app-exception__img app-exception__img--403"}),_c('h1',[_vm._v("403")]),_c('p',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }